// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatBackgroundSelection__container-e4703a {
  padding: 8px 24px;
}

.ChatBackgroundSelection__carousel-a7ba95 {
  --prev-button-wrapper-left: -24px;
  --next-button-wrapper-right: -24px;
}

.ChatBackgroundSelection__carousel-a7ba95 button {
  z-index: 1;
}

.ChatBackgroundSelection__item-bfe057 {
  border-radius: 16px;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  height: 88px;
  width: 88px;
}

.ChatBackgroundSelection__upload-deff99 {
  align-items: center;
  background-color: var(--base-20);
  display: flex;
  justify-content: center;
}

.ChatBackgroundSelection__upload-deff99:before {
  box-shadow: none;
}

.ChatBackgroundSelection__background-pattern-d76735 {
  border-radius: 16px;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/components/Appearance/ChatBackgroundSelection/ChatBackgroundSelection.styles.m.css"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,iCAAA;EACA,kCAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,gBAAA;AACF","sourcesContent":[".container {\n  padding: 8px 24px;\n}\n\n.carousel {\n  --prev-button-wrapper-left: -24px;\n  --next-button-wrapper-right: -24px;\n}\n\n.carousel button {\n  z-index: 1;\n}\n\n.item {\n  border-radius: 16px;\n  box-sizing: border-box;\n  cursor: pointer;\n  position: relative;\n  height: 88px;\n  width: 88px;\n}\n\n.upload {\n  align-items: center;\n  background-color: var(--base-20);\n  display: flex;\n  justify-content: center;\n}\n\n.upload:before {\n  box-shadow: none;\n}\n\n.background-pattern {\n  border-radius: 16px;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChatBackgroundSelection__container-e4703a`,
	"carousel": `ChatBackgroundSelection__carousel-a7ba95`,
	"item": `ChatBackgroundSelection__item-bfe057`,
	"upload": `ChatBackgroundSelection__upload-deff99`,
	"background-pattern": `ChatBackgroundSelection__background-pattern-d76735`,
	"backgroundPattern": `ChatBackgroundSelection__background-pattern-d76735`
};
module.exports = ___CSS_LOADER_EXPORT___;
